import { message } from "antd";
import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import actions from "../actions/actions";
import getAddressMeters from "./getAddressMeters";
import getAddresses from "./getAddresses";

const deleteMeter = (meter, houseId) => async (dispatch) =>  {
  const url = "/Meter/delete_meter";
  try {
		dispatch({ type: actions.ITEM_LOADING });
		await client.delete(
			url,
			{
				headers: authHeader(),
        params: { meterId: meter.id },
			}
		);
		message.success(`Счётчик №${meter.meterCode} удалён`);
		dispatch(getAddresses({}));
		dispatch(getAddressMeters(houseId));
	} catch (e) {
		message.error("При удалении счётчика произошла ошибка");
		console.log(e);
	}
}

export default deleteMeter;